import { Component, OnInit, ElementRef, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IContactes, IContactesResponse } from '../../contactes/contactes.interfaces';
import { IClientsSocis } from '../../clientsSocis/clientssocis.interfaces';

import { ProposalsService } from '../../services/projects-proposals-service/projects-proposals.service';
import { ContactesService } from '../../services/contactes/contactes.service';
import { NotesServiceContactes } from '../notes_contactes/notes.service_contactes';
import { ClientsSocisService } from '../../services/clients_socis/clientsSocis.service';
import { StripHtmlPipe } from '../../pipes/stripHTMLpipe';
import { DatePipe } from '@angular/common';

import * as moment from 'moment';

@Component({
  selector: 'dialog-Data',
  templateUrl: './dialog.component.contactes.html',
  styleUrls: ['./dialog.component.contactes.scss'],
  providers: [ProposalsService, ContactesService, ClientsSocisService, NotesServiceContactes, DatePipe]
})

export class DialogContactes {
  private contactesModel: IContactes = {
  'id': 'NEW',
  'nom': null,
  'tipus': null,
  'email': null,
  'tlf': null,
//  'skype': null,
  'linkedin': null,
  'mobil': null,
  'comentari': null,
  'adreca': null,
  'empresa': null,
  'id_client': null,
  'ambit': null,
  'professional': null,
  'nota': null,
  'data_nota': null,
  'pais': null,
  'tematica1': null,
  'tematica2': null,
  'tematica3': null,
  'tematica4': null,
  'tematica5': null
  };
  private id: string;
  public error: string = '';
  public dia: string = null;
  public showAsyncProgress: boolean = false;
  public editContacteData: IContactes;
  public tematica1: Array<string>;
  public tematica2: Array<string>;
  public tematica3: Array<string>;
  public tematica4: Array<string>;
  public tematica5: Array<string>;
  public possibleTematiques1: Array<any>;
  public possibleTematiques2: Array<any>;
  public possibleTematiques3: Array<any>;
  public possibleTematiques4: Array<any>;
  public possibleTematiques5: Array<any>;
  public possibleTipus: Array<string> = [];
  public possiblePaisos: Array<string> = [];
  public llistaClients: Array<IClientsSocis>;
  public tbEmpreses: any;
  public userInfo: any = {};
  public projectes: any;
  public projecte: number = null;
  public quillPos: number = 0;
  public ambit: Array<string>;

  @ViewChild('quillEditor', { static: false }) editor;

  public filterStates(val: string) {
    if(!this.tbEmpreses)this.tbEmpreses=this.llistaClients;
    
    if(val)return this.llistaClients.filter(item => item.nom.toLowerCase().startsWith(val.toLowerCase()));
    return this.llistaClients;
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, protected dataService: ProposalsService,private datePipe: DatePipe, private contactesService: ContactesService, private notesService: NotesServiceContactes, private clientsSocisService: ClientsSocisService, public dialogRef: MatDialogRef<DialogContactes>, @Inject(MAT_DIALOG_DATA) public data: any){ 
   this.editContacteData =  data.dades;
   if(!this.dia)this.dia = moment().format("YYYY-MM-DD");
   this.ambit = (this.editContacteData && this.editContacteData.ambit?this.editContacteData.ambit.split(";"):null);
   this.clientsSocisService.getList(100000,0,{},{},{'nom': 'ASC'})
    .subscribe(
       clientsSocis=> { 
          this.llistaClients = clientsSocis.rows;
          //Quan venim d'una proposta carrega el nom de l'empresa
          if(this.editContacteData.id_client)this.editContacteData.empresa = this.llistaClients.find(item => item.id == this.editContacteData.id_client).nom;
        },
       error => console.log(error)
    );

    this.clientsSocisService.getAutocomplete("countryCliSoc")
    .subscribe(
      data=> {this.possiblePaisos = data.filter(elem => elem.text != '').map(item => item.text);},
      error => console.log(error)
    );

   this.userInfo = data.user;
   this.dataService.getTematiques(1)
    .subscribe(
      temes => {this.possibleTematiques1 = temes;
        this.tematica1 = (this.data && this.data.tematica1?this.data.tematica1.split(";"):'');
        this.dataService.getTematiques(2)
        .subscribe(
          temes => {
          this.possibleTematiques2 = temes;
          this.tematica2 = (this.data && this.data.tematica2?this.data.tematica2.split(";"):'');

          this.dataService.getTematiques(3)
          .subscribe(
            temes => {this.possibleTematiques3 = temes;
            this.tematica3 = (this.data && this.data.tematica3?this.data.tematica3.split(";"):'');
            this.dataService.getTematiques(4)
            .subscribe(
              temes => {this.possibleTematiques4 = temes;
              this.tematica4 = (this.data && this.data.tematica4?this.data.tematica4.split(";"):'');
              this.dataService.getTematiques(5)
              .subscribe(
                temes => {this.possibleTematiques5 = temes;
                this.tematica5 = (this.data && this.data.tematica5?this.data.tematica5.split(";"):'');
                this.notesService.getAutocomplete('codiProjNota').subscribe(projecte => this.projectes = projecte, err => {return;});
              });
            });
          });
        });
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    if(this.editContacteData.nom == "" || !this.editContacteData.nom){alert("Cal omplir el camp Nom.");return;}
    if(this.editContacteData.email == "" || !this.editContacteData.email){alert("Cal omplir el camp email.");return;}
    if(!this.ambit){alert("Cal omplir el camp Àmbit.");return;}
    if(!this.editContacteData.tipus)this.editContacteData.tipus = "";
    else if(this.editContacteData.tipus.length > 100){alert("El contingut de 'Càrrec' ha de ser inferior a 100 caràcters.");return;}

    //Autocomplete. Recupera id_client del nom empresa seleccionat
    let id_client = (this.llistaClients.find(item => item.nom === this.editContacteData.empresa)?this.llistaClients.find(item => item.nom === this.editContacteData.empresa).id:0);
    if(id_client != 'NEW')this.editContacteData.id_client = id_client;
    //FI Auocomplete. Recupera id_client del nom empresa seleccionatt
    this.editContacteData.ambit = this.ambit.join(";");
   
    this.editContacteData.data_nota = this.datePipe.transform(new Date(),"yyyy-MM-dd");
    this.editContacteData.nota = this.editor.quillEditor.root.innerHTML;

    this.data.tematica1 = (this.tematica1[0]?this.tematica1.join(";"):null);
    this.data.tematica2 = (this.tematica2[0]?this.tematica2.join(";"):null);
    this.data.tematica3 = (this.tematica3[0]?this.tematica3.join(";"):null);
    this.data.tematica4 = (this.tematica4[0]?this.tematica4.join(";"):null);
    this.data.tematica5 = (this.tematica5[0]?this.tematica5.join(";"):null);

    this.dialogRef.close(this.editContacteData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  afegir(event){
    //data
    if(!event){
      this.editContacteData.nota = "[" + this.dia + "] ("+this.userInfo.name+"): <p>&nbsp;</p>" + (this.editContacteData.nota?this.editContacteData.nota:'') + "<p>&nbsp;</p>";
    }
    //projecte
    if(event){
      this.projecte = event.value;
      this.editor.quillEditor.format('color', 'dark-green'); 
      this.editor.quillEditor.insertText(this.quillPos, "★ "+event.source.triggerValue+" ★", {'color': '#009900','bold': true});
    }
  }

  setPos(event){
    if(event.range)this.quillPos = event.range.index;
    else if(event.oldRange)this.quillPos = event.oldRange.index;
  }

  ngOnInit(){ }

}
